import { render, staticRenderFns } from "./FooterIconText.vue?vue&type=template&id=3a451efc&scoped=true"
import script from "./FooterIconText.vue?vue&type=script&lang=js"
export * from "./FooterIconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a451efc",
  null
  
)

export default component.exports